<template>
  <div class="item-quantity">
    <p
      :class="[disableSubtract ? 'disable' : '', 'subtract']"
      @click="decreaseQty"
    />
    <p class="item-amount">
      {{ quantity }}
    </p>
    <p
      :class="[disableAdd ? 'disable' : '', 'add']"
      @click="increaseQty"
    />
  </div>
</template>

<script>

export default {

  props: ['candelete', 'maxqty', 'quantity', 'updating'],
  computed: {
    disableAdd() {
      return this.quantity >= this.maxqty || this.updating == 'true'
    },

    disableSubtract() {
      if (this.candelete == 'true') {
        return this.updating == 'true'
      } else {
        return this.quantity <= 1 || this.updating == 'true'
      }
    },
  },

  methods: {
    decreaseQty() {
      if (this.disableSubtract) { return }

      if (this.quantity <= 1) {
        this.$emit('delete-item')
      } else {
        this.$emit('update-qty', this.quantity - 1)
      }
    },

    increaseQty() {
      if (this.disableAdd) { return }
      this.$emit('update-qty', this.quantity + 1)
    }
  }
}
</script>
